import * as React from "react";

const hrefLang = (props) => {
  const original = props.url.replace(`/${props.lang}/`, ``);
  return (
    <>
      <link rel="alternate" hrefLang="x-default" href={original} />
      {props.lang != process.env.GATSBY_LANG && (
        <link rel="alternate" hrefLang={process.env.GATSBY_LANG} href={original} />
      )}
      {props.lang != process.env.GATSBY_LANG ||
        props.avaible.map((lang) => <link key={lang} rel="alternate" hrefLang={lang} href={`${original}/${lang}/`} />)}
    </>
  );
};

export default hrefLang;
